<template>
  <div class="mx-auto flex flex-col relative">
    <div class="flex bg-g0-dark items-center p-2 px-3 pointer-events-all">
      <!-- LOGO -->
      <div @click="goHome()" class="mr-3 pr-3 border-g1 border-r-2 cursor-pointer ">
        <SVG name="logo" css="w-[35px] fill-current"></SVG>
      </div>

      <!-- QUICKSTATUS -->
      <div class="flex">
        <QuickStatus v-if="device?.config" :config="device?.config" />
      </div>

      <!-- Nom -->
      <div
        class="flex flex-col justify-around text-[10px] text-white mr-3 pr-3 border-r-2 border-g0"
      >
        <!-- DOCK -->
        <template v-if="device?.config?.dock?.id != undefined">
          <DockStatus :config="device.config" />
        </template>

        <!-- RC+ -->
        <template v-if="device?.config?.rcPlus?.id != undefined">
          <RcPlusStatus :config="device.config" />
        </template>

        <!-- DRONE -->
        <template v-if="device?.config?.drone?.id != undefined">
          <DroneStatus :config="device.config" />
        </template>
      </div>

      <Flight_Flight
        :config="device.config"
        v-if="Number.isInteger(device?.config?.flight?.id)"
      />

      <DroneRTK_GPS :config="device.config" v-if="device?.config?.drone?.id" />

      <DroneBatt :config="device.config" v-if="device?.config?.drone?.id" />

      <div class="border-g0 border-l-2 h-full mx-2"></div>

      <div
        v-if="device?.config?.dock?.id != undefined"
        class="flex h-full ml-1 p-1 cursor-pointer"
        @click="$root.global.menuPopupOpen = !$root.global.menuPopupOpen"
      >
        <svg
          class="w-[15px] fill-white"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 40 8"
        >
          <circle id="Ellipse_2" data-name="Ellipse 2" cx="4" cy="4" r="4" />
          <circle
            id="Ellipse_3"
            data-name="Ellipse 3"
            cx="4"
            cy="4"
            r="4"
            transform="translate(16)"
          />
          <circle
            id="Ellipse_4"
            data-name="Ellipse 4"
            cx="4"
            cy="4"
            r="4"
            transform="translate(32)"
          />
        </svg>
      </div>
      <template v-if="device?.config?.rcPlus?.id != undefined">
        <RcPlusSdr :config="config">
          <RcPlusSdrNetQuality :config="config" />
        </RcPlusSdr>
      </template>
    </div>

    <DroneFlightBatt :config="device.config" v-if="device?.config?.drone?.id" />
  </div>
</template>

<script>
import SVG from "@/partials/SVG.vue";
import { toast } from "vue3-toastify";

import Flight_Flight from "@/app/popup/partial/Flight_Flight.vue";
import QuickStatus from "@/app/popup/partial/QuickStatus.vue";
import DroneRTK_GPS from "@/app/popup/partial/Drone/DroneRTK_GPS.vue";
import DroneBatt from "@/app/popup/partial/Drone/DroneBatt.vue";
import DroneFlightBatt from "@/app/popup/partial/Drone/DroneFlightBatt.vue";
import DockStatus from "@/partials/Device/Template/Dock/DockStatus.vue";
import RcPlusStatus from "@/partials/Device/Template/Rc+/RcPlusStatus.vue";
import DroneStatus from "@/partials/Device/Template/Drone/DroneStatus.vue";
import RcPlusSdrNetQuality from "@/partials/Device/Template/Rc+/RcPlusSdrNetQuality.vue";
import RcPlusSdr from "@/partials/Device/Template/Rc+/RcPlusSdr.vue";

export default {
  name: "POPUP_TOP",
  components: {
    SVG,
    Flight_Flight,
    QuickStatus,
    DroneRTK_GPS,
    DroneBatt,
    DroneFlightBatt,
    DockStatus,
    RcPlusStatus,
    DroneStatus,
    RcPlusSdrNetQuality,
    RcPlusSdr,
  },
  props: {
    device: Object,
  },
  setup() {
    return {};
  },

  mounted() {},

  methods: {
    goHome() {
      this.$router.getRoutes().forEach((route) => {
        if (route.name == "Site") {
          let path = route.path.replace(
            ":sit_id(\\d+)",
            this.device.sit_id
          );

          this.$router.push(path);
          setTimeout(() => {
            window.location.reload();
          }, 500);
        }
      });
    }
  },
};
</script>
